// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".label[data-v-b2859882]{position:absolute;left:0;bottom:1.6vw;z-index:1;color:#666;font-size:3.733vw;font-family:PingFangHK-Regular;font-weight:400;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
